export default {"src":"/_next/static/media/icon-color.878d3643.svg","height":42,"width":84};